import {
  readInt,
  readOneOf,
  readSubsetOf,
} from "@/utils/search-params";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import {
  ACTIVE_VALUES,
  DEFAULT_PAGE,
  DEFAULT_PER_PAGE,
  RECIPIENT_SORT_COLUMNS,
  RecipientSortColumn,
  SECTOR_EMAILS_PARAMS,
  SECTORS,
  SHIPPING_TYPE_VALUES,
  SORT_DIRECTIONS,
  SectorEnum,
  ShippingTypeEnum,
  SortDirection,
} from "../../constants";
import { SectorEmailsFilters } from "../types";

const ACTIVE_PARAM_VALUES: readonly string[] = ACTIVE_VALUES.map(String);

const readActive = (raw: string | null): boolean[] =>
  readSubsetOf(raw, ACTIVE_PARAM_VALUES).map(
    (value: string): boolean => value === String(true),
  );

export const useSectorEmailsFilters = (): SectorEmailsFilters => {
  const [searchParams] = useSearchParams();

  return useMemo((): SectorEmailsFilters => {
    const sort: RecipientSortColumn | undefined = readOneOf(
      searchParams.get(SECTOR_EMAILS_PARAMS.SORT),
      RECIPIENT_SORT_COLUMNS,
    );
    const direction: SortDirection | undefined = readOneOf(
      searchParams.get(SECTOR_EMAILS_PARAMS.DIRECTION),
      SORT_DIRECTIONS,
    );

    return {
      search: searchParams.get(SECTOR_EMAILS_PARAMS.SEARCH) ?? "",
      active: readActive(searchParams.get(SECTOR_EMAILS_PARAMS.ACTIVE)),
      sectors: readSubsetOf<SectorEnum>(
        searchParams.get(SECTOR_EMAILS_PARAMS.SECTORS),
        SECTORS,
      ),
      shipping_types: readSubsetOf<ShippingTypeEnum>(
        searchParams.get(SECTOR_EMAILS_PARAMS.SHIPPING_TYPES),
        SHIPPING_TYPE_VALUES,
      ),
      meta: {
        page: readInt(
          searchParams.get(SECTOR_EMAILS_PARAMS.PAGE),
          DEFAULT_PAGE,
        ),
        perPage: readInt(
          searchParams.get(SECTOR_EMAILS_PARAMS.PER_PAGE),
          DEFAULT_PER_PAGE,
        ),
      },
      sorting: sort ? { sort, direction } : {},
    };
  }, [searchParams]);
};
